import {Component, OnInit, Input, OnDestroy, ElementRef} from '@angular/core';
import {Project} from '../../../data/project/project';
import {ProjectComment} from '../../../data/project/project-comment';
import {ProjectService} from '../../../data/project/project.service';
import {User} from 'projects/core/src/lib/login/data/user';
import {AppStateQuery} from 'projects/desktop/src/app/data/app-state.query';
import {getUserAvatar} from '../../../../profile/utils/profile.utils';
import {UserService} from 'projects/core/src/lib/login/data/user.service';
import {trackEntityById} from 'projects/core/src/public-api';
import {WsService} from '../../../../data/ws.service';
import {WsUpdateResponce} from '../../../../data/ws-update-responce';
import {EntityProject} from '../../../data/project/entity-project';
import {Task} from 'projects/desktop/src/app/modules/home-page/data/tasks/task';
import {
  TaskEditDialogComponent
} from 'projects/desktop/src/app/modules/home-page/view/home-board/dash-board-main-block/task-column/task-edit-dialog/task-edit-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {DeviceDetectorService} from 'ngx-device-detector';
import {debounceTime, filter, takeUntil} from 'rxjs/operators';
import {Subject, Subscription, timer} from 'rxjs';
import {RxJSUnsubscribable} from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import {RxJSUnsubscribe} from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import moment from 'moment';

@Component({
  selector: 'app-activities-block',
  templateUrl: './activities-block.component.html',
  styleUrls: ['./activities-block.component.scss'],
  providers: [DeviceDetectorService]
})
@RxJSUnsubscribe
export class ActivitiesBlockComponent implements OnInit, OnDestroy, RxJSUnsubscribable {

  @Input()
  project: Project;

  editItem = -1;
  replyItem = -1;
  editReplyItem = -1;

  currentUser: User;

  users: User[];

  trackEntityById = trackEntityById;

  isMobile: boolean;

  wsSub: Subscription;

  constructor(
    protected dialog: MatDialog,
    protected wsService: WsService,
    protected userService: UserService,
    protected elementRef: ElementRef,
    protected deviceDetectorService: DeviceDetectorService,
    protected projectService: ProjectService,
    protected appStateQuery: AppStateQuery
  ) {
  }

  ngOnInit() {
    this.appStateQuery.currentUser$.subscribe(user => this.currentUser = user)

    this.userService.getActiveUsers().pipe(takeUntil(this.getUnsubFromAllSubs())).subscribe(users => {
      users.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      })
      this.users = users
    })

    this.getComments()

    this.wsSub = this.wsService
      .listenUntilDestroyed<WsUpdateResponce<EntityProject>>('/topic/update/model.comment.ProjectComment', this)
      .pipe(
        debounceTime(500),
        filter(updateInfo => updateInfo.entity.project.id === this.project.id)
      )
      .subscribe(() => {
        this.getComments()
      })

    this.isMobile = this.deviceDetectorService.isMobile();
  }

  getComments() {
    this.projectService.getProjectComments(this.project.id).subscribe(comments => {

      if (comments) {
        this.project.comments = comments;
        this.project.comments.forEach(comm => {
          const commYear = moment(comm.createdTime).year()
          const currYear = moment().year()

          if (currYear > commYear) {
            comm.moreThanYear = true
          }
        })

      }
    })
  }

  editComment(comment: ProjectComment) {
    this.editItem = comment.id;
    this.editReplyItem = -1;
    this.replyItem = -1;
  }

  editReplyComment(comment: ProjectComment) {
    this.editItem = -1;
    this.replyItem = -1;
    this.editReplyItem = comment.id;
  }

  replyComment(projectComment: ProjectComment, replyProjectComment?: ProjectComment) {
    this.editItem = -1;
    this.editReplyItem = -1;
    this.replyItem = projectComment.id;

    timer(1).subscribe(() => {
      const textAreas = this.elementRef.nativeElement.getElementsByClassName('reply-text-area');


      if (replyProjectComment) {
        if (replyProjectComment.user.id !== this.currentUser.id) {
          textAreas[0].value = '@' + replyProjectComment.user.username + ' '
        }
      } else {
        if (projectComment.user.id !== this.currentUser.id) {
          textAreas[0].value = '@' + projectComment.user.username + ' '
        }
      }

    })


  }

  deleteComment(comment: ProjectComment) {
    this.projectService.deleteComment(this.project.id, comment.id).subscribe(() => {
      const index = this.project.comments.indexOf(comment, 0);
      if (index > -1) {
        this.project.comments[index].deleted = true;
      }
      this.editItem = -1;
    })
  }

  deleteReplyComment(projectComment: ProjectComment, replyComment: ProjectComment) {
    this.projectService.deleteComment(this.project.id, replyComment.id).subscribe(() => {
      const index = projectComment.replies.indexOf(replyComment, 0);
      if (index > -1) {
        projectComment.replies[index].deleted = true;
      }
      this.editReplyItem = -1;
    })
  }

  onEditBlockClosed() {
    this.editItem = -1;
    this.replyItem = -1;
    this.editReplyItem = -1;
  }

  onUpdateItem(comment: ProjectComment) {
    const foundedItem = this.project.comments.find(foundedComment => foundedComment.id === comment.id)
    foundedItem.text = comment.text;
    foundedItem.mentions = comment.mentions;
    this.editItem = -1;
  }

  onUpdateReplyItem(projectComment: ProjectComment, replyComment: ProjectComment) {
    const foundedItem = projectComment.replies.find(foundedComment => foundedComment.id === replyComment.id)
    foundedItem.text = replyComment.text;
    foundedItem.mentions = replyComment.mentions;
    this.editReplyItem = -1;
    this.replyItem = -1;
  }

  getShortname(user: User) {
    return getUserAvatar(user).shortName
  }

  getColor(user: User) {
    return getUserAvatar(user).color
  }

  createTask(comment: ProjectComment) {
    const tempData = {
      entityId: comment.id
    } as Task

    this.dialog.open(TaskEditDialogComponent, {
      data: {
        task: tempData,
        buttonLabel: 'Create',
        taskType: 'comment',
        entityId: comment.id,
        projectId: this.project.id,
        projectName: this.project.name
      },
      panelClass: 'task-edit-dialog',
      disableClose: false
    });
  }

  ngOnDestroy() {
    if (this.wsSub) {
      this.wsSub.unsubscribe()
      this.wsSub = null;
    }
  }

  getUnsubFromAllSubs(): Subject<boolean> {
    return null
  }
}
